import { startCase } from "lodash";
import i18n from "../../../../constants/i18n";
import { USER_CONSUMABLES_HEADERS } from "../../../../constants/table-custom-headers/User";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import Et3Table from "../../../../core/et3-table";
import getUserConsumablesStore from "../../../../stores/user-store/consumables-store";

const UserConsumablesData = withLiteObserverAndTheme(() => {
  const consumablesData = getUserConsumablesStore().consumablesData.get();

  const isConsumablesDataEmpty = Object.values(consumablesData).every(
    (value) => `${value}`.trim() === ""
  );
  const rows = isConsumablesDataEmpty
    ? []
    : Object.entries(consumablesData).map(([key, value]) => {
        return {
          attribut: startCase(key),
          value: `${value}`
        };
      });

  return (
    <Et3Table
      columns={USER_CONSUMABLES_HEADERS}
      rows={rows}
      title={i18n.get("CONSUMABLES")}
      titleKey={"USER_CONSUMABLE_TABLE"}
      shouldBeFlagged={false}
    />
  );
});

export default UserConsumablesData;
